// import {
//     CalendarEventAction
// } from 'angular-calendar';

import {
    startOfMonth,
    endOfDay,
    subDays,
    addDays,
    endOfMonth,
    isSameDay,
    isSameMonth,
    addHours,
    startOfDay
} from 'date-fns';


export class CalendarEventModel
{
  start: Date;
  end?: Date;
  validated: boolean;
  // actions?: CalendarEventAction[];

  constructor(data?)
  {
    data = data || {};
    this.start = new Date(data.start) || startOfDay(new Date());
    this.end = new Date(data.end) || endOfDay(new Date());
    this.validated = data.validated || true;
  }

}



// WEBPACK FOOTER //
// /usr/app/src/app/main/content/app/transactions/event.model.ts